import React, { useState, useRef } from "react";
import "./FilterReportJobs.scss";
import { MenuItem, TextField, Modal, FormControl } from "@mui/material";
import { CSVLink } from "react-csv";

import SearchIcon from "@mui/icons-material/Search";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import EventNoteIcon from "@mui/icons-material/EventNote";

import CalendarRange from "../../PopUp/CalendarRange/CalendarRange";
import graphqlRequest from "../../../requestMethod";
import eventHelpers from "../../../Helpers/Event";

//

const FilterReportJobs = ({
  fetchAllData,
  csvData,
  filterDate,
  setFilterDate,
  tableData,
  setFilterTable,
  globalInputSearch,
  SetGlobalInputSearch,
  departmentList,
  departmentValue,
  setDepartmentValue,
  professionsValue,
  setProfessionValue,
  professionalList,
  exportPDF,
  handleCsvDownload,
  keyword,
  setKeyword,
  filterByProfession,
  setFilterByProfession,
  filterByDepartment,
  setFilterByDepartment,
  filterByStartDate,
  setFilterByStartDate,
  filterByEndDate,
  setFilterByEndDate,
  totalData,
  title,
  downloadTable,
}) => {
  let [downloadOption, setDownloadOption] = useState("");
  let [openRangeCalendar, setOpenRangeCalendar] = useState(false);
  const searchInputRef = useRef(null);

  const handleDownloadChange = (e) => {
    // console.log("48-->", totalData)
    setDownloadOption(e?.target?.value);
    // if (e.target.value === "PDF") {
    //   exportPDF(totalData);
    // } else if (e.target.value === "CSV") {
    //   // const csvData = totalData;
    //   csvData(totalData)
    // }
  };

  const handleDownload = () => {
    if (downloadOption === "PDF") {
      exportPDF(totalData);
    } else if (downloadOption === "CSV") {
      const csvData = totalData;
    }
  };

  function resetAll() {
    setDepartmentValue("");
    setProfessionValue("");
    setFilterByProfession("");
    setFilterByDepartment("");
    setKeyword("");
    setFilterByStartDate("");
    setFilterByEndDate("");
    SetGlobalInputSearch("");
    setFilterTable(tableData);
    setDownloadOption("");
    setOpenRangeCalendar("");
    fetchAllData();
    setFilterDate([{ key: "selection" }]);
  }
  function formatDate(date) {
    // return date instanceof Date ? date.toLocaleDateString("en-GB"): date;
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  // const fetchUserId = async () => {
  //   let data = localStorage.getItem("auth");
  //   let token = JSON.parse(data)?.accessToken;
  //   try {
  //     const query = `
  //   query {
  //     withAuth(token: "${token}"){
  //      userDetails{
  //       id,
  //       name {
  //         salutation
  //         first
  //         middle
  //         last
  //         full
  //       },
  //       emails {
  //         isPrimary
  //         isVerified
  //         address
  //       }
  //     }
  //     }
  //   }
  //     `;
  //     const response = await graphqlRequest(query);
  //     // console.log("175-->",response)
  //     return response;
  //   } catch (error) {
  //     console.error("Error sending GraphQL request:", error);
  //   }
  // };

  // const trackReOpenJobDwnld = async () => {
  //   const user = await fetchUserId();
  //   // console.log("user---->", user);
  //   const userId = user.data.withAuth.userDetails.id;
  //   const userName = user.data.withAuth.userDetails.name.full;
  //   const userEmail = user.data.withAuth.userDetails.emails[0].address;
  //   if (window.Moengage) {
  //     //set unique id
  //     window.Moengage.add_unique_user_id(userId);
  //     //set user attributes
  //     window.Moengage.add_user_name(userName);
  //     window.Moengage.add_email(userEmail);
  //     //set event data
  //     window.Moengage.track_event(
  //       eventHelpers.OPN_JB_DWNLD
  //       // {
  //       // "ID": userId,
  //       // "name": userName,
  //       // "Email": userEmail,
  //       // "date": Date.now(),
  //       //}
  //     );
  //     // window.Moengage.destroy_session();
  //   }
  // };

  console.log("deparmentList", departmentList);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // // backgroundColor: "white",
      }}
    >
      <div className="sl-filter">
     
        <FormControl sx={{}}>
          <TextField
            select
                       sx={{ width: "170px", "& .MuiOutlinedInput-root": { borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", "& fieldset": { border: "none" } } }}
          
            size="small"
              label={!filterByDepartment ? "Department" : ""}
            value={filterByDepartment || ""}
            InputLabelProps={{ shrink: false }}
            onChange={(e) => setFilterByDepartment(e?.target?.value)}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            {departmentList?.map((data) => (
              <MenuItem value={data}>{data}</MenuItem>
            ))}
          </TextField>
        </FormControl>

        <FormControl sx={{}}>
          <TextField
            select
           sx={{ width: "170px", "& .MuiOutlinedInput-root": { borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", "& fieldset": { border: "none" } } }}

            size="small"
            label={!filterByProfession ? "Profession" : ""}
            value={filterByProfession || ""}
            InputLabelProps={{ shrink: false }}
            onChange={(e) => setFilterByProfession(e?.target?.value)}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            {professionalList?.map((data) => (
              <MenuItem value={data}>{data}</MenuItem>
            ))}
          </TextField>
        </FormControl>
        <TextField
          select
          size="small"
        sx={{ width: "170px", "& .MuiOutlinedInput-root": { borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", "& fieldset": { border: "none" } } }}

          value={downloadOption}
          onChange={() => {
            handleDownloadChange();
            // trackReOpenJobDwnld()
          }}
          label={!downloadOption ? "Download" : ""}  // Conditional label
InputLabelProps={{ shrink: false }}     // Prevents shrinking
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Select"
        >
          <MenuItem disabled value="">
            Download
          </MenuItem>

          <MenuItem
            value="PDF"
            disabled={!downloadTable || downloadTable.length === 0}
          >
            <span
              onClick={() => {
                exportPDF();
                // trackReOpenJobDwnld()
              }}
            >
              Download as PDF
            </span>
          </MenuItem>
          <MenuItem value="CSV"
            disabled={!csvData || csvData?.length <= 1}>
            {" "}
            {/* <CSVLink data={csvData}>Download as CSV</CSVLink> */}
            <CSVLink data={csvData} filename={`${title} Report.csv`}  onClick={handleCsvDownload}>
              Download as CSV
            </CSVLink>
          </MenuItem>
        </TextField>
        <label className={`global-report-search-container ${keyword ? 'has-text' : ''}`}>
        <div onClick={() => searchInputRef.current?.focus()}>
            <SearchIcon />
          </div>
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search"
            value={keyword}
            onChange={(e) => setKeyword(e?.target?.value)}
          />
        
        </label>
        <div className={`date-range-wrapper ${filterByStartDate && filterByEndDate ? 'has-dates' : ''}`}>
        <label className="date-range-container">
        <div onClick={() => setOpenRangeCalendar(!openRangeCalendar)}>
            <EventNoteIcon />
          </div>
          <input
            type="text"
            placeholder="Search"
            // value={
            //   filterDate[0]?.startDate
            //     ? `${filterDate[0]?.startDate?.toLocaleDateString()} - ${filterDate[0]?.endDate?.toLocaleDateString()} `
            //     : "Date Range"
            // }
            // value={
            //   filterByStartDate instanceof Date && filterByEndDate instanceof Date
            //     ? `${filterByStartDate.toLocaleDateString()} - ${filterByEndDate.toLocaleDateString()}`
            //     : "Date Range"
            // }
            value={
              filterByStartDate && filterByEndDate
                ? `${formatDate(filterByStartDate)} - ${formatDate(
                    filterByEndDate
                  )}`
                : "Date Range"
            }
          />
        
        </label>
        </div>
        
        <div className="filter-button-a" onClick={resetAll}
            style={{ borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", backgroundColor: "white" }}>

             {/* style={{  backgroundColor: "white", borderRadius:"5px", border: "none" }}> */}
            <RotateLeftIcon />
          </div>

      </div>

  
      
    
      <Modal
        open={openRangeCalendar}
        onClose={() => setOpenRangeCalendar(!openRangeCalendar)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <CalendarRange
          setOpenRangeCalendar={setOpenRangeCalendar}
          // setFilterDate={setFilterDate}
          // filterDate={filterDate}
          filterByStartDate={filterByStartDate}
          setFilterByStartDate={setFilterByStartDate}
          filterByEndDate={filterByEndDate}
          setFilterByEndDate={setFilterByEndDate}
        />
      </Modal>
    </div>
  );
};

export default FilterReportJobs;
